import React, { useState } from "react";
import {
  SmartFormInterFace,
  SmartSoftForm,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import * as XLSX from "xlsx";
import { INVOICE_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";

import SmartFileDisplay from "../../components/site/SmartFileDisplay";
import { post } from "../../services/smartApiService";
import { showAlertAutoClose } from "../../services/notifyService";
// interface HeaderProps {
//   loadTableData: () => void;
// }
interface FormErrors {
  [key: string]: string | null;
}
interface componentProps {
  loadData: () => void;
  id: string | undefined;
}
const VendorDetailsImport: React.FC<componentProps> = ({ loadData, id }) => {
  const [formData, setFormData] = useState<any>({});
  const [formSubmit, setFormSubmit] = useState<boolean>(false);
  const { closeModal } = useSiteContext();
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [data, setData] = useState<any[]>([]);

  const downloadTemplate = () => {
    const headers = [
      "Transaction Reference Number", "Invoice Number", "Invoice Date", "Hub Name",
      "Supply Type", "Invoice Type", "Supply Category", "Transaction Type",
      "Transaction Subtype", "Supplier PAN", "Reverse Charge", "Supplier Legal Name",
      "Org Code", "Supplier Address 1", "Supplier City", "Supplier State",
      "Supplier PIN Code", "Goods/Services", "HSN Code", "HSN Description",
      "PO Number", "PO Date", "Line item ID", "Quantity", "UQC", "",
      "Rate per Quantity", "Gross Value", "", "Discount Before GST", "Freight",
      "Pre Taxable Value", "Taxable Value", "GST Rate", "IGST Amount", "CGST Amount",
      "SGST/ UTGST Amount", "Total Taxable Value", "Total IGST Amount",
      "Total CGST Amount", "Total SGST/UTGST Amount.TCS", "Invoice Value",
      "Payment Terms", "Buyer GSTIN/UIN", "Buyer Legal Name", "Buyer Address 1",
      "Buyer Address 2", "Buyer City", "Buyer State", "Buyer PIN Code",
      "Ship to Legal Name", "Ship to Address 1", "Ship to Address 2", "Ship to City",
      "Ship to State", "Ship to PIN Code", "Receiver E mail ID", "LR No",
      "Transporter Name", "Vehicle No", "Remarks", "Auto Generate IRN",
      "Auto Generate EWB", "EWB Sub Supply Type", "EWB Sub Supply Type Description",
      "EWB Transaction Type", "Transport Mode", "Type of Cargo", "Distance level(km)",
      "Transporter ID", "Transport Document No", "Transport Document Date",
      "Transporter e-mail", "Entity-1", "Entity-2", "Dispatch Name",
      "Dispatch Address 1", "Dispatch Address 2", "Dispatch City", "Dispatch State",
      "Dispatch PIN Code", "Dispatcher E mail ID", "Dispatcher Phone Number",
      "Ship Code", "Ship to Trade Name", "Ship to GSTIN", "Receiver Phone Number",
      "E Commerce GSTIN", "Payee Name", "Payment Mode", "Bank Account Number",
      "Bank IFSC code", "Payment Instructions", "Credit Transfer Terms",
      "Direct Debit Terms", "Credit Days", "Amount Paid", "Amount Due", "Due Date",
      "Shipping Bill Number", "Shipping Bill Date", "Export Duty Amount", "Port Code",
      "Tax Scheme", "Invoice Currency Code", "Invoice Period Start Date",
      "Invoice Period End Date", "Preceding Invoice Number", "Preceding Invoice Date",
      "Other Reference Number", "Receipt Advice Number", "Receipt Advice Date",
      "Lot/Batch Reference Number", "Contract Reference Number",
      "External Reference Number", "Project Reference Number",
      "Supporting Document URL", "Other Supporting Document",
      "Any Other Additional Information", "Total Invoice Value in Foreign Currency",
      "Option for Supplier for Refund", "Foreign Currency", "Customer Country Code",
      "Total Cess Amount", "Total State Cess Amount", "Rounding Off Amount",
      "Discount at Invoice level", "Charges at Invoice level",
      "Flag for Supply covered under sec 7 of IGST Act", "Original Invoice Value",
      "Original POS", "Original Transaction Type", "Original Transaction ID",
      "Differential Percentage", "Schedule Description Code",
      "Exemption Notification No", "Compensation Cess Description Code",
      "RCM Description Code", "Bar code of Product", "Batch Name", "Warranty Date",
      "Expiry Date", "Cess Rate", "State Cess Rate", "Cess Non Advol Value",
    ];

    const empty = Array(headers.length).fill("");

    const row1 = [...empty];
    row1[0]  = "TXN001";         row1[1]  = "INV-001";
    row1[2]  = "01-01-2024";     row1[3]  = "Hub01";
    row1[4]  = "B2B";            row1[5]  = "Regular";
    row1[7]  = "Regular";        row1[9]  = "ABCDE1234F";
    row1[10] = "N";              row1[11] = "Sample Supplier Ltd";
    row1[14] = "Bangalore";      row1[15] = "Karnataka";
    row1[16] = "560001";         row1[17] = "Services";
    row1[18] = "998313";         row1[32] = "10000";
    row1[33] = "18";             row1[35] = "1800";
    row1[37] = "10000";          row1[38] = "1800";
    row1[41] = "11800";          row1[44] = "MOOVING";
    row1[47] = "Bangalore";      row1[48] = "Karnataka";
    row1[49] = "560001";

    const row2 = [...empty];
    row2[0]  = "TXN002";         row2[1]  = "INV-002";
    row2[2]  = "02-01-2024";     row2[3]  = "Hub02";
    row2[4]  = "B2B";            row2[5]  = "Regular";
    row2[7]  = "Regular";        row2[9]  = "XYZAB5678G";
    row2[10] = "N";              row2[11] = "Sample Supplier Ltd";
    row2[14] = "Delhi";          row2[15] = "Delhi";
    row2[16] = "110001";         row2[17] = "Services";
    row2[18] = "998313";         row2[32] = "20000";
    row2[33] = "18";             row2[35] = "3600";
    row2[37] = "20000";          row2[38] = "3600";
    row2[41] = "23600";          row2[44] = "Customer B";
    row2[47] = "Delhi";          row2[48] = "Delhi";
    row2[49] = "110001";

    const ws = XLSX.utils.aoa_to_sheet([headers, row1, row2]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "invoice_irn_ack_template.xlsx");
  };

  const handleSubmit = () => {
    setFormSubmit(true);
    let URL = INVOICE_URLS.IMPORT_EXCEL;
    let _data = { ...formData };
    _data["id"] = id;
    //console.log(formData);
    const subscription = post(URL, _data).subscribe((response) => {
      setData(response.data);
      loadData();
      if (response.data.length < 1) {
        showAlertAutoClose("imported", "success");
        closeModal();
      }
      // closeModal();
      // loadTableData()
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const handleSubmitZip = () => {
    setFormSubmit(true);
    let URL = INVOICE_URLS.IMPORT_ZIP;
    let _data = { ...formData };
    _data["id"] = id;
    // console.log(formData);
    const subscription = post(URL, _data).subscribe((response) => {
      setData(response.data);
      loadData();
      if (response.data.length < 1) {
        showAlertAutoClose("imported", "success");
        closeModal();
      }
      // closeModal();
      // loadTableData()
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const ImportForm = () => {
    const handleInputChange = (name: string, value: any) => {
      setFormData((prev: any) => ({ ...prev, [name]: value }));
    };
    const filePreviewFunctionDisplay = (name: string = "excel") => {
      return (
        <SmartFileDisplay
          files={formData[name] || []}
          updateImages={(images: any) => handleInputChange(name, images)}
          isMulti={false}
          index={0}
        />
      );
    };

    const handleErrorChange = (name: string | any, value: any) => {
      setFormErrors((prev) => {
        const updatedFormData = { ...prev };
        if (value === null || value === "") {
          delete updatedFormData[name];
        } else {
          updatedFormData[name] = value;
        }
        return updatedFormData;
      });
    };
    const formElements: SmartFormInterFace.SmartFormElementProps[] = [
      {
        type: "FILE",
        width: "6",
        name: "excel",
        element: {
          placeHolder: (
            <p>
              Browser Excel <span className="smart-error">*</span>
            </p>
          ),
          fileNameEnable: false,
          leftIcon: "fa fa-cloud-upload",
          accept: "application/excel",
          //  isMulti: true,
          isRequired: true,
          filePreview: true,
          filePreviewFunction: () => filePreviewFunctionDisplay("excel"),
          classList: [""],
        },
      },
      {
        type: "BUTTON",
        width: "6",
        name: "button",
        element: {
          classList: ["button ", "smart-action-button"],
          label: "Upload EXCEL",
          onClick: () => {
            handleSubmit();
          },
        },
      },

      {
        type: "FILE",
        width: "6",
        name: "import_zip",
        element: {
          placeHolder: (
            <p>
              Browser ZIP <span className="smart-error">*</span>
            </p>
          ),
          fileNameEnable: false,
          leftIcon: "fa fa-cloud-upload",
          accept: "application/zip",
          //  isMulti: true,
          isRequired: true,
          filePreview: true,
          filePreviewFunction: () => filePreviewFunctionDisplay("import_zip"),
          classList: [""],
        },
      },

      // {
      //   type: "LABEL",
      //   width: "4",
      //   name: "file_dispaly",
      //   labelFunction: () => {
      //     return <SmartFileDisplay files={formData.excel} />
      //   }
      // },
      {
        type: "BUTTON",
        width: "6",
        name: "button",
        element: {
          classList: ["button ", "smart-action-button"],
          label: "Upload ZIP",
          onClick: () => {
            handleSubmitZip();
          },
        },
      },
    ];
    return (
      <>
        <SmartSoftForm
          formData={formData}
          setFormData={handleInputChange}
          elements={formElements}
          formSubmit={formSubmit}
          handleErrorChange={handleErrorChange}
          className="is-gapless"
        />
      </>
    );
  };

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "4" },
    { title: "Invoice Number", index: "invoice_number", width: "14" },
    { title: "IRN", index: "irn", width: "18" },
    { title: "ACK No", index: "ack_no", width: "12" },
    { title: "ACK Date", index: "ack_date", width: "10" },
    {
      title: "Status",
      index: "status",
      width: "10",
      type: "tags",
      tags: [
        { value: 5, label: "Success", class: "is-success" },
        { value: 10, label: "Error", class: "is-danger" },
      ],
    },
    {
      title: "Remarks",
      index: "msg",
      width: "15",
    },
  ];
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-12",
      custom: <>{ImportForm()}</>,
    },
  ];

  return (
    <>
      <div className="mb-4">
        <button className="button is-warning" onClick={downloadTemplate}>
          <span className="icon">
            <i className="fa fa-download"></i>
          </span>
          <span>Download Template</span>
        </button>
        <p className="is-size-7 has-text-grey mt-1">
          Download the sample Excel template with the required columns before uploading.
        </p>
      </div>
      {ImportForm()}
      {data && data.length > 0 && (
        <SmartTable
          columns={columns}
          data={data}
          paginationProps={{
            pageSize: 0,
          }}
          tableProps={{
            className: " is-hoverable is-bordered is-striped ",
            isResponsive: true,
          }}
          //tableTop={tableTop}
        />
      )}
      {/* <div className="has-text-centered">
        <SmartSoftButton
          label="Cancel"
          classList={["button", "mt-4 mr-4", "smart-third-button"]}
          onClick={closeModal}
        />
      </div> */}
    </>
  );
};

export default VendorDetailsImport;
